// extracted by mini-css-extract-plugin
export default {"table":"printTableStyle_table__Igqbs","headerCell":"printTableStyle_headerCell__288N7","cell":"printTableStyle_cell__JrYeX","summary":"printTableStyle_summary__N3GN2"};